module.exports = __webpack_public_path__ + "img/W-G18.b80f4cc3.jpg";